import { useTranslation } from "react-i18next";
import Heading from "@/components/atoms/Heading";
import InvoiceArchiveTable from "@/components/organisms/InvoiceArchiveTable";
import styles from "./styles.module.css";

export default function InvoiceArchive() {
  const { t } = useTranslation();

  return (
    <>
      <title>{`Reviver - ${t("common:archivedDocuments")}`}</title>
      <meta name="description" content={t("common:archivedDocuments")} />
      <div className={styles.archiveRoot}>
        <div className={styles.contentRoot}>
          <Heading order={1} styleOrder={4} strong mb={24} mt={32}>
            {t("common:archivedDocuments")}
          </Heading>
          <InvoiceArchiveTable initialRowsPerPage={15} />
        </div>
      </div>
    </>
  );
}
